export const CONSTANTS = {
    DROP_HOVER_ATTR: 'ngflowchart-drop-hover',
    CANVAS_CONTENT_CLASS: 'ngflowchart-canvas-content',
    CANVAS_CONTENT_ID: 'ngflowchart-canvas-content',
    CANVAS_CLASS: 'ngflowchart-canvas',
    CANVAS_STEP_CLASS: 'ngflowchart-canvas-step',
}